__turbopack_context__.v({
  "skylinesFigure": "hTuR-G_skylinesFigure",
  "skylinesImage": "hTuR-G_skylinesImage",
  "video": "hTuR-G_video",
  "videoCopy": "hTuR-G_videoCopy",
  "videoWrapper": "hTuR-G_videoWrapper",
});
